import { useLocation } from "react-router-dom";
import { Navbar } from '../../common' ;
import img from "../../../logo/image.png";

import './Header.css';

function Header () {
  const location = useLocation();
  const hideNavbar = location.pathname === "/error" || location.pathname === "/set-password" || location.pathname === "/forgotPassword";

  return (
    <section className="header">
      <section className="header-top">
        <section className="header-top__logo">
          <a href="https://sentryti.com" className="header-logo"> 
             <img src={img} className="header-logo-img" width="100%" alt="logo"/>
          </a>
        </section>
        {!hideNavbar && (<section className="header-top__navbar">
          <section className="header-top__navigation">
            <Navbar />
          </section>
        </section>)}
      </section>
    </section>
  )
}

export default Header;